import {
  ACTION_POST_JOB_TRIGGER,
  ACTION_POST_JOB_TRIGGER_SUCCESS,
  ACTION_POST_JOB_TRIGGER_FAILURE,
  ACTION_RESET_JOB_TRIGGER,
} from '../configs/ActionTypes';

export type TriggerJobState = {
  success: boolean | null;
  isLoading: boolean;
  lastResponse: object | null;
};

const initialState: TriggerJobState = {
  success: null,
  isLoading: false,
  lastResponse: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_POST_JOB_TRIGGER: {
      return {
        ...state,
        success: null,
        isLoading: true,
      };
    }

    case ACTION_POST_JOB_TRIGGER_SUCCESS: {
      return {
        ...state,
        success: true,
        isLoading: false,
        lastResponse: action.payload,
      };
    }

    case ACTION_POST_JOB_TRIGGER_FAILURE: {
      return {
        ...state,
        success: false,
        isLoading: false,
        lastResponse: action.payload ?? null,
      };
    }

    case ACTION_RESET_JOB_TRIGGER: {
      return {
        ...initialState,
      };
    }

    default: {
      return state;
    }
  }
}
